'use client'

import React from 'react'
import { useAuth } from '../context/AuthContext'
import { useAppKit } from '@reown/appkit/react'

interface UserAuthStatusProps {
  showEmail?: boolean
  onConnect?: () => void
}

const UserAuthStatus: React.FC<UserAuthStatusProps> = ({
  showEmail = false,
  onConnect,
}) => {
  const { user, isLoading, isAuthenticated } = useAuth()
  const { open } = useAppKit()

  const handleConnect = async () => {
    await open()
    if (onConnect) onConnect()
  }

  if (isLoading) {
    return <div className="auth-status loading">Loading...</div>
  }

  if (isAuthenticated && user) {
    return (
      <div className="auth-status authenticated">
        <div className="wallet-address">
          {user.walletAddress.substring(0, 6)}...
          {user.walletAddress.substring(user.walletAddress.length - 4)}
        </div>
        {showEmail && user.verifiedEmail && (
          <div className="email-status verified">
            {user.email}
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="auth-status anonymous">
      <button onClick={handleConnect} className="connect-wallet-btn">
        Connect Wallet
      </button>
    </div>
  )
}

export default UserAuthStatus 